import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-floating-buttons',
  templateUrl: './contact-floating-buttons.component.html',
  styleUrls: ['./contact-floating-buttons.component.scss'],
})
export class ContactFloatingButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
